module.exports = {
	"config": {
		"blogTitle": "håken.no",
		"authorName": "Håken Lid",
		"authorAbout": "Full stack web developer and designer",
		"linkPrefix": "",
		"github": "https://github.com/haakenlid",
		"codepen": "http://codepen.io/haakenlid/",
		"stackoverflow": "http://stackoverflow.com/users/1977847/?tab=profile",
		"twitter": "https://twitter.com/haakenlid"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"path": "_favicons.html",
				"isAbsolute": false,
				"absolute": "/home/haakenlid/projects/hken.no/_favicons.html",
				"root": "",
				"dirname": "",
				"basename": "_favicons.html",
				"extname": ".html",
				"name": "_favicons",
				"ext": "html"
			},
			"requirePath": "_favicons.html",
			"data": {
				"body": "<link rel=\"icon\" type=\"image/png\" sizes=\"192x192\" href=\"/favicon/android-chrome-192x192.png\">\n<link rel=\"manifest\" href=\"/favicon/manifest.json\">\n<meta name=\"mobile-web-app-capable\" content=\"yes\">\n<meta name=\"theme-color\" content=\"#fff\">\n<meta name=\"application-name\" content=\"haken.no\">\n<link rel=\"apple-touch-icon\" sizes=\"57x57\" href=\"/favicon/apple-touch-icon-57x57.png\">\n<link rel=\"apple-touch-icon\" sizes=\"60x60\" href=\"/favicon/apple-touch-icon-60x60.png\">\n<link rel=\"apple-touch-icon\" sizes=\"72x72\" href=\"/favicon/apple-touch-icon-72x72.png\">\n<link rel=\"apple-touch-icon\" sizes=\"76x76\" href=\"/favicon/apple-touch-icon-76x76.png\">\n<link rel=\"apple-touch-icon\" sizes=\"114x114\" href=\"/favicon/apple-touch-icon-114x114.png\">\n<link rel=\"apple-touch-icon\" sizes=\"120x120\" href=\"/favicon/apple-touch-icon-120x120.png\">\n<link rel=\"apple-touch-icon\" sizes=\"144x144\" href=\"/favicon/apple-touch-icon-144x144.png\">\n<link rel=\"apple-touch-icon\" sizes=\"152x152\" href=\"/favicon/apple-touch-icon-152x152.png\">\n<link rel=\"apple-touch-icon\" sizes=\"180x180\" href=\"/favicon/apple-touch-icon-180x180.png\">\n<meta name=\"apple-mobile-web-app-capable\" content=\"yes\">\n<meta name=\"apple-mobile-web-app-status-bar-style\" content=\"black-translucent\">\n<meta name=\"apple-mobile-web-app-title\" content=\"haken.no\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"16x16\" href=\"/favicon/favicon-16x16.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"32x32\" href=\"/favicon/favicon-32x32.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"96x96\" href=\"/favicon/favicon-96x96.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"230x230\" href=\"/favicon/favicon-230x230.png\">\n<link rel=\"shortcut icon\" href=\"/favicon/favicon.ico\">"
			}
		},
		{
			"file": {
				"path": "_template.js",
				"isAbsolute": false,
				"absolute": "/home/haakenlid/projects/hken.no/_template.js",
				"root": "",
				"dirname": "",
				"basename": "_template.js",
				"extname": ".js",
				"name": "_template",
				"ext": "js"
			},
			"requirePath": "_template.js",
			"templatePath": "//"
		},
		{
			"file": {
				"path": "404.js",
				"isAbsolute": false,
				"absolute": "/home/haakenlid/projects/hken.no/404.js",
				"root": "",
				"dirname": "",
				"basename": "404.js",
				"extname": ".js",
				"name": "404",
				"ext": "js"
			},
			"requirePath": "404.js",
			"path": "/404/"
		},
		{
			"file": {
				"path": "blog/cards-pwa/index.md",
				"isAbsolute": false,
				"absolute": "/home/haakenlid/projects/hken.no/blog/cards-pwa/index.md",
				"root": "",
				"dirname": "blog/cards-pwa",
				"basename": "index.md",
				"extname": ".md",
				"name": "index",
				"ext": "md"
			},
			"requirePath": "blog/cards-pwa/index.md",
			"data": {},
			"path": "/blog/cards-pwa/"
		},
		{
			"file": {
				"path": "blog/conference-programme/index.md",
				"isAbsolute": false,
				"absolute": "/home/haakenlid/projects/hken.no/blog/conference-programme/index.md",
				"root": "",
				"dirname": "blog/conference-programme",
				"basename": "index.md",
				"extname": ".md",
				"name": "index",
				"ext": "md"
			},
			"requirePath": "blog/conference-programme/index.md",
			"data": {},
			"path": "/blog/conference-programme/"
		},
		{
			"file": {
				"path": "blog/cropping-1-algorithm/index.js",
				"isAbsolute": false,
				"absolute": "/home/haakenlid/projects/hken.no/blog/cropping-1-algorithm/index.js",
				"root": "",
				"dirname": "blog/cropping-1-algorithm",
				"basename": "index.js",
				"extname": ".js",
				"name": "index",
				"ext": "js"
			},
			"requirePath": "blog/cropping-1-algorithm/index.js",
			"path": "/blog/cropping-1-algorithm/"
		},
		{
			"file": {
				"path": "blog/cropping-2-react/index.md",
				"isAbsolute": false,
				"absolute": "/home/haakenlid/projects/hken.no/blog/cropping-2-react/index.md",
				"root": "",
				"dirname": "blog/cropping-2-react",
				"basename": "index.md",
				"extname": ".md",
				"name": "index",
				"ext": "md"
			},
			"requirePath": "blog/cropping-2-react/index.md",
			"data": {},
			"path": "/blog/cropping-2-react/"
		},
		{
			"file": {
				"path": "blog/cropping-3-python/index.ipynb",
				"isAbsolute": false,
				"absolute": "/home/haakenlid/projects/hken.no/blog/cropping-3-python/index.ipynb",
				"root": "",
				"dirname": "blog/cropping-3-python",
				"basename": "index.ipynb",
				"extname": ".ipynb",
				"name": "index",
				"ext": "ipynb"
			},
			"requirePath": "blog/cropping-3-python/index.ipynb",
			"path": "/blog/cropping-3-python/"
		},
		{
			"file": {
				"path": "blog/illustrations/index.md",
				"isAbsolute": false,
				"absolute": "/home/haakenlid/projects/hken.no/blog/illustrations/index.md",
				"root": "",
				"dirname": "blog/illustrations",
				"basename": "index.md",
				"extname": ".md",
				"name": "index",
				"ext": "md"
			},
			"requirePath": "blog/illustrations/index.md",
			"data": {},
			"path": "/blog/illustrations/"
		},
		{
			"file": {
				"path": "blog/infographics/index.md",
				"isAbsolute": false,
				"absolute": "/home/haakenlid/projects/hken.no/blog/infographics/index.md",
				"root": "",
				"dirname": "blog/infographics",
				"basename": "index.md",
				"extname": ".md",
				"name": "index",
				"ext": "md"
			},
			"requirePath": "blog/infographics/index.md",
			"data": {},
			"path": "/blog/infographics/"
		},
		{
			"file": {
				"path": "blog/menneskerettighetsuka/index.md",
				"isAbsolute": false,
				"absolute": "/home/haakenlid/projects/hken.no/blog/menneskerettighetsuka/index.md",
				"root": "",
				"dirname": "blog/menneskerettighetsuka",
				"basename": "index.md",
				"extname": ".md",
				"name": "index",
				"ext": "md"
			},
			"requirePath": "blog/menneskerettighetsuka/index.md",
			"data": {},
			"path": "/blog/menneskerettighetsuka/"
		},
		{
			"file": {
				"path": "blog/monogram/index.md",
				"isAbsolute": false,
				"absolute": "/home/haakenlid/projects/hken.no/blog/monogram/index.md",
				"root": "",
				"dirname": "blog/monogram",
				"basename": "index.md",
				"extname": ".md",
				"name": "index",
				"ext": "md"
			},
			"requirePath": "blog/monogram/index.md",
			"data": {},
			"path": "/blog/monogram/"
		},
		{
			"file": {
				"path": "blog/norwegianstyle/index.md",
				"isAbsolute": false,
				"absolute": "/home/haakenlid/projects/hken.no/blog/norwegianstyle/index.md",
				"root": "",
				"dirname": "blog/norwegianstyle",
				"basename": "index.md",
				"extname": ".md",
				"name": "index",
				"ext": "md"
			},
			"requirePath": "blog/norwegianstyle/index.md",
			"data": {},
			"path": "/blog/norwegianstyle/"
		},
		{
			"file": {
				"path": "blog/real-estate-brochure/index.md",
				"isAbsolute": false,
				"absolute": "/home/haakenlid/projects/hken.no/blog/real-estate-brochure/index.md",
				"root": "",
				"dirname": "blog/real-estate-brochure",
				"basename": "index.md",
				"extname": ".md",
				"name": "index",
				"ext": "md"
			},
			"requirePath": "blog/real-estate-brochure/index.md",
			"data": {},
			"path": "/blog/real-estate-brochure/"
		},
		{
			"file": {
				"path": "blog/universitas-cms/index.md",
				"isAbsolute": false,
				"absolute": "/home/haakenlid/projects/hken.no/blog/universitas-cms/index.md",
				"root": "",
				"dirname": "blog/universitas-cms",
				"basename": "index.md",
				"extname": ".md",
				"name": "index",
				"ext": "md"
			},
			"requirePath": "blog/universitas-cms/index.md",
			"data": {},
			"path": "/blog/universitas-cms/"
		},
		{
			"file": {
				"path": "blog/universitas-print-design/index.md",
				"isAbsolute": false,
				"absolute": "/home/haakenlid/projects/hken.no/blog/universitas-print-design/index.md",
				"root": "",
				"dirname": "blog/universitas-print-design",
				"basename": "index.md",
				"extname": ".md",
				"name": "index",
				"ext": "md"
			},
			"requirePath": "blog/universitas-print-design/index.md",
			"data": {},
			"path": "/blog/universitas-print-design/"
		},
		{
			"file": {
				"path": "blog/universitas-website/index.md",
				"isAbsolute": false,
				"absolute": "/home/haakenlid/projects/hken.no/blog/universitas-website/index.md",
				"root": "",
				"dirname": "blog/universitas-website",
				"basename": "index.md",
				"extname": ".md",
				"name": "index",
				"ext": "md"
			},
			"requirePath": "blog/universitas-website/index.md",
			"data": {},
			"path": "/blog/universitas-website/"
		},
		{
			"file": {
				"path": "blog/velkomstbilag/index.md",
				"isAbsolute": false,
				"absolute": "/home/haakenlid/projects/hken.no/blog/velkomstbilag/index.md",
				"root": "",
				"dirname": "blog/velkomstbilag",
				"basename": "index.md",
				"extname": ".md",
				"name": "index",
				"ext": "md"
			},
			"requirePath": "blog/velkomstbilag/index.md",
			"data": {},
			"path": "/blog/velkomstbilag/"
		},
		{
			"file": {
				"path": "blog/wikipedia-single-page-app/index.md",
				"isAbsolute": false,
				"absolute": "/home/haakenlid/projects/hken.no/blog/wikipedia-single-page-app/index.md",
				"root": "",
				"dirname": "blog/wikipedia-single-page-app",
				"basename": "index.md",
				"extname": ".md",
				"name": "index",
				"ext": "md"
			},
			"requirePath": "blog/wikipedia-single-page-app/index.md",
			"data": {},
			"path": "/blog/wikipedia-single-page-app/"
		},
		{
			"file": {
				"path": "index.js",
				"isAbsolute": false,
				"absolute": "/home/haakenlid/projects/hken.no/index.js",
				"root": "",
				"dirname": "",
				"basename": "index.js",
				"extname": ".js",
				"name": "index",
				"ext": "js"
			},
			"requirePath": "index.js",
			"path": "/"
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 384
// module chunks = 0